import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

export const StyledIcon = styled(SWReactIcons)`
    path {
        fill: ${colorsPalettes.indigo[300]} !important;
    }
`;
